import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';

export default [
  {
    path: '/more',
    component: () => import('@/views/more/'),
    meta: {
      // 260611 typeC 리뉴얼: 마이페이지는 자체 헤더(제목 '마이'+알림벨)를 렌더하므로 전역 헤더 OFF.
      isHeader: false,
      isNav: true,
      titleName: '마이',
      isBell: true,
      isHome: true,
      isSetting: true,
      isFooter: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/more/user/update',
    component: () => import('@/views/more/user/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '회원정보 수정하기'
    }
  },
  {
    path: '/more/user/update/password',
    component: () => import('@/views/more/user/UpdatePassword.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '비밀번호 변경하기'
    }
  },
  {
    path: '/more/setting',
    component: () => import('@/views/more/setting/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '설정'
    }
  },
  {
    path: '/more/notification',
    component: () => import('@/views/more/notification/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '알림'
    }
  },
  {
    path: '/more/notification/:notificationNo',
    component: () => import('@/views/more/notification/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '알림 상세보기'
    }
  },
  // 260423: 기존 젊은 통계 UI → 고령친화 select/stats 라우트로 redirect (UX 일관)
  {
    path: '/more/signboard-stats',
    redirect: '/business/signboard/select?target=stats'
  },
  {
    path: '/more/memorial',
    component: () => import('@/views/more/memorial/index.vue'),
    meta: {
      isHeader: false,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '추모관 관리'
    }
  },
  {
    path: '/more/andersen',
    component: () => import('@/views/more/andersen/MyAndersenList.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '안데르센관 관리'
    }
  },
  {
    path: '/more/form/memorial/:memorialNo',
    component: () => import('@/views/memorial/register/step2.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/more/form/memorial/anniversary/:memorialNo',
    component: () => import('@/views/memorial/register/step3.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },

  {
    path: '/more/form/memorial/background/:memorialNo',
    component: () => import('@/views/memorial/register/step4.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      subName: '추모관 수정하기',
      expression: KEEP_ALIVE_OBJECT.MEMORIAL_REGISTER.expression
    }
  },
  {
    path: '/more/funeral',
    component: () => import('@/views/more/funeral/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 장례식장 관리'
    }
  },
  {
    path: '/more/funeral/form/:funeralNo',
    component: () => import('@/views/more/funeral/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 장례식장 수정하기'
    }
  },
  {
    path: '/more/announcement',
    component: () => import('@/views/more/announcement/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 부고장 관리'
    }
  },
  {
    path: '/more/announcement/form/:announcementNo',
    component: () => import('@/views/more/announcement/update.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 부고장 수정하기'
    }
  },

  {
    path: '/more/payment',
    component: () => import('@/views/more/payment/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '결제내역'
    }
  },
  {
    path: '/more/item/buy',
    component: () => import('@/views/more/item/Shop.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '상품구매'
    }
  },
  {
    path: '/more/setting/family',
    component: () => import('@/views/more/setting/family/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족관리'
    }
  },
  {
    path: '/more/setting/family/search',
    component: () => import('@/views/more/setting/family/search.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족검색'
    }
  },
  {
    path: '/more/setting/family/search/:familyCode',
    component: () => import('@/views/more/setting/family/search.vue'),
    meta: {
      isHeader: true,
      isBack: false,
      isNav: false,
      titleName: '가족검색'
    }
  },
  {
    path: '/more/setting/family/register',
    component: () => import('@/views/more/setting/family/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '가족생성'
    }
  },
  {
    path: '/more/item',
    component: () => import('@/views/more/item/MyItemList.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '내 상품'
    }
  },
  {
    path: '/more/church',
    component: () => import('@/views/more/church/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '교회,기독교 묘원 및 단체 소속 신청'
    }
  },
  {
    path: '/more/death',
    component: () => import('@/views/more/death/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '사망 확인서 제출'
    }
  },
  {
    path: '/more/notice',
    component: () => import('@/views/more/notice/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '공지사항'
    }
  },
  {
    path: '/more/notice/:noticeNo',
    component: () => import('@/views/more/notice/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '공지사항'
    }
  },
  {
    path: '/more/inquiry',
    component: () => import('@/views/more/inquiry/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '고객센터'
    }
  },
  {
    path: '/more/inquiry/:inquiryNo',
    component: () => import('@/views/more/inquiry/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '문의하기'
    }
  },
  {
    path: '/more/inquiry/register',
    component: () => import('@/views/more/inquiry/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '문의하기'
    }
  },
  {
    path: '/more/inquiry/withdraw/register',
    component: () => import('@/views/more/inquiry/withdraw/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '탈퇴 문의하기'
    }
  },
  {
    path: '/more/faq',
    component: () => import('@/views/more/faq/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '자주 묻는 질문'
    }
  },
  {
    path: '/more/faq/:faqNo',
    component: () => import('@/views/more/faq/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '자주 묻는 질문'
    }
  },
  {
    path: '/more/law',
    component: () => import('@/views/more/law/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '법률검토'
    }
  },
  {
    path: '/more/law/register/:lawyerNo',
    component: () => import('@/views/more/law/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '법률검토 신청하기'
    }
  },

  {
    path: '/more/like/pray',
    component: () => import('@/views/more/like/LikePrayList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      // subName: '좋아요 기도 모아보기',
      titleName: '좋아요 기도 모아보기'
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/more/like/business',
    component: () => import('@/views/more/like/LikeBusinessList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      // 260612 typeC 리뉴얼 — 헤더 타이틀 '좋아요' (우측 홈·햄버거는 260421 회의 전 페이지 공통이라 유지)
      titleName: '좋아요'
    }
  },
  // 260428: 마케팅 알림 구독한 사업장 목록
  {
    path: '/more/subscribe/business',
    component: () => import('@/views/more/subscribe/SubscribedBusinessList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      titleName: '구독'
    }
  },
  {
    path: '/more/user/withdraw',
    component: () => import('@/views/more/user/Withdraw.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '회원탈퇴'
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/more/premium',
    component: () => import('@/views/more/premium/index.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      titleName: '내 프리미엄 포인트',
      isHome: true
    }
  },
  // 260424 오후회의2: 기존 회원도 마이페이지에서 관심 업종 편집 가능
  {
    path: '/more/interest-category',
    component: () => import('@/views/more/InterestCategoryEdit.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '관심 업종 고르기'
    }
  },
  // 260428 5월오픈 4번: 알림 카테고리 6종 + quiet hours + 채널 광고 동의
  {
    path: '/more/notification-settings',
    component: () => import('@/views/more/notification/Settings.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '알림 설정'
    }
  }
];
